import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import type React from 'react';
type BaseButtonProps = {
  variant?: 'primary' | 'ghost' | 'minor';
  children: React.ReactNode;
  className?: string;
  translate?: 'yes' | 'no';
  id?: string;
};
type LinkButtonProps = BaseButtonProps & {
  href: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  'aria-label'?: string;
  prefetch?: boolean | null;
};
type NativeButtonProps = BaseButtonProps & {
  href: undefined;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};
type ButtonProps = LinkButtonProps | NativeButtonProps;
function isLinkButtonProps(props: ButtonProps): props is LinkButtonProps {
  return typeof (props as LinkButtonProps).href === 'string';
}
export function Button(props) {
  const $ = _c(26);
  const {
    variant: t0,
    children,
    className: t1,
    translate
  } = props;
  const variant = t0 === undefined ? "primary" : t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      primary: "bg-ink text-white px-5 py-3.5 shadow-soft hover:shadow-lg",
      ghost: "bg-white text-ink border border-line px-4 py-3.5 hover:border-ink",
      minor: "bg-white text-ink border border-[color:color-mix(in_srgb,var(--color-ink)_18%,transparent)] px-4 py-2.5 text-xs hover:border-[color:color-mix(in_srgb,var(--color-ink)_50%,transparent)]"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const variantStyles = t2;
  if (isLinkButtonProps(props)) {
    const {
      href,
      onClick,
      "aria-label": ariaLabel,
      prefetch,
      id
    } = props;
    const isInternal = href.startsWith("/");
    if (isInternal) {
      const t3 = `${"\n    inline-flex items-center gap-2 rounded-full uppercase\n    text-sm font-medium tracking-up\n    transition-transform duration-300\n    hover:-translate-y-0.5\n  "} ${variantStyles[variant]} ${className}`;
      let t4;
      if ($[1] !== ariaLabel || $[2] !== children || $[3] !== href || $[4] !== id || $[5] !== onClick || $[6] !== prefetch || $[7] !== t3 || $[8] !== translate) {
        t4 = <Link href={href} id={id} className={t3} onClick={onClick} aria-label={ariaLabel} translate={translate} prefetch={prefetch}>{children}</Link>;
        $[1] = ariaLabel;
        $[2] = children;
        $[3] = href;
        $[4] = id;
        $[5] = onClick;
        $[6] = prefetch;
        $[7] = t3;
        $[8] = translate;
        $[9] = t4;
      } else {
        t4 = $[9];
      }
      return t4;
    }
    const t3 = `${"\n    inline-flex items-center gap-2 rounded-full uppercase\n    text-sm font-medium tracking-up\n    transition-transform duration-300\n    hover:-translate-y-0.5\n  "} ${variantStyles[variant]} ${className}`;
    let t4;
    if ($[10] !== ariaLabel || $[11] !== children || $[12] !== href || $[13] !== id || $[14] !== onClick || $[15] !== t3 || $[16] !== translate) {
      t4 = <a href={href} id={id} className={t3} target="_blank" rel="noopener noreferrer" onClick={onClick} aria-label={ariaLabel} translate={translate}>{children}</a>;
      $[10] = ariaLabel;
      $[11] = children;
      $[12] = href;
      $[13] = id;
      $[14] = onClick;
      $[15] = t3;
      $[16] = translate;
      $[17] = t4;
    } else {
      t4 = $[17];
    }
    return t4;
  }
  const {
    type,
    disabled,
    onClick: onClick_0,
    id: id_0
  } = props;
  const t3 = type ?? "button";
  const t4 = `${"\n    inline-flex items-center gap-2 rounded-full uppercase\n    text-sm font-medium tracking-up\n    transition-transform duration-300\n    hover:-translate-y-0.5\n  "} ${variantStyles[variant]} ${className}`;
  let t5;
  if ($[18] !== children || $[19] !== disabled || $[20] !== id_0 || $[21] !== onClick_0 || $[22] !== t3 || $[23] !== t4 || $[24] !== translate) {
    t5 = <button type={t3} id={id_0} className={t4} onClick={onClick_0} disabled={disabled} translate={translate}>{children}</button>;
    $[18] = children;
    $[19] = disabled;
    $[20] = id_0;
    $[21] = onClick_0;
    $[22] = t3;
    $[23] = t4;
    $[24] = translate;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  return t5;
}